module.exports = __webpack_public_path__ + "static/media/19ESCAP16.1aec79a5.jpg";